import request from '../untils/request';

export const supplierList = params => {
  return request({
    url: '/supplier/supplier/list',
    params,
  });
};

export const supplierCreate = params => {
  return request({
    url: '/supplier/supplier/create',
    params,
  });
};

export const supplierModify = params => {
  return request({
    url: '/supplier/supplier/modify',
    params,
  });
};

export const supplierDelete = params => {
  return request({
    url: '/supplier/supplier/delete-account',
    params,
  });
};

export const supplierReset = params => {
  return request({
    url: '/supplier/supplier/reset-pass',
    params,
  });
};

export const supplierGoodsList = params => {
  return request({
    url: '/supplier/supplier/supplier-goods-list',
    params,
  });
};

export const supplierViewGoodsList = params => {
  return request({
    url: '/supplier/supplier/goods-list',
    params,
  });
};

export const supplierAddGoods = params => {
  return request({
    url: '/supplier/supplier/add-goods',
    params,
  });
};

export const supplierDeleteGoods = params => {
  return request({
    url: '/supplier/supplier/delete-goods',
    params,
  });
};

export const supplierEntityList = params => {
  return request({
    url: '/supplier/entity/list',
    params,
  });
};

export const supplierEntityOpenAccount = params => {
  return request({
    url: '/supplier/entity/enterprise-account',
    params,
  });
};
